export const assets = {
  logo: 'assets/images/mindbase_logo.svg',
  logo1: 'assets/images/mindbase_logo1.svg',
  logo3: 'assets/images/logo@3x.png',
  coming_soon:'assets/images/coming_soon.svg',
  userPlaceholderLogo: 'assets/images/profileWhite.png',
  AuthAttachment1: 'assets/images/auth_attachment1.jpg',
  studentImage : 'assets/images/student_image.png',
  collegeImage: 'assets/images/college1.png',
  planner_Icon: 'assets/images/teacher.png',
  changeLanguageIcon: 'assets/images/Global.svg',
  ntfy_logo: 'assets/images/notify_logo.png',
  assessment_Icon: 'assets/images/clipboard-text.png',
  dummyCollegeImage: 'assets/images/college_photo.png',
  college_list_Icon: 'assets/images/book.svg',
  college_Admission_Icon: 'assets/images/buildings.png',
  adminIcon: 'assets/images/profile.png',
  placeHolderLogo: 'assets/images/placeholder.png',
  assignOne: 'assets/images/assign1.png',
  educationPng: 'assets/images/ai_education.png',
  fileIcon1: 'assets/images/file.svg',
  viewIcon: 'assets/images/view_icon.svg',
  editIcon: 'assets/images/edit_icon.svg',
  delete_icon1:'assets/images/delete_group_icon.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  RevenueIcon: 'assets/images/revenue_icon.svg',
  CmsIcon: 'assets/images/cms_icon.svg',
  CategoryIcon: 'assets/images/category_icon.svg',
  NotificationIcon: 'assets/images/notification.svg',
  ReportIcon: 'assets/images/reports_icon.svg',
  searchIcon: 'assets/images/search_icon.svg',
  UsersIcon: 'assets/images/user_icon.svg',
  AnalyticIcon: 'assets/images/analytic_icon.svg',
  SubAdminIcon: 'assets/images/sub_admin_icon.svg',
  CameraIcon: 'assets/images/camera_icon.svg',
  RatingIcon: 'assets/images/rating_icon.svg',
  BookingIcon: 'assets/images/booking_icon.svg',
  ReportingIcon: 'assets/images/reporting_icon.svg',
  sendIcon: 'assets/images/send_icon.svg',
  offerIcon: 'assets/images/offers_icon.svg',
  VendorIcon: 'assets/images/vendor_icon.svg',
  cuisineIcon: 'assets/images/cuisine_icon.svg',
  moneyIcon: 'assets/images/money_icon.svg',
  replyIcon: 'assets/images/reply-icon.svg',
  settingIcon: 'assets/images/setting_icon.svg',
  docIcon: 'assets/images/doc_icon.svg',
  pictureIcon: 'assets/images/picture_icon.svg',
  videoIcon: 'assets/images/video_icon.svg',
  pdfIcon: 'assets/images/pdf_icon.svg',
  calenderIcon: 'assets/images/calender.svg',
  packageIcon: 'assets/images/package.svg',
  payrollIcon: 'assets/images/payroll.svg',
  projectIcon: 'assets/images/project.svg',
  schoolIcon: 'assets/images/school.svg',
  subjectIcon: 'assets/images/subject.svg',
  yserlogsIcon: 'assets/images/yserlogs.svg',
  workflowIcon: 'assets/images/workflow.svg',
  googleCalender: 'assets/images/google-calender.png',
  outlookCalender: 'assets/images/outlook-calender.png',
  appleCalender: 'assets/images/apple-calender.png',
  eyeIcon: 'assets/images/eye_icon.svg',
  eyeIcon2: 'assets/images/eye_icon2.svg',
  authBg: 'assets/images/auth_bg.png',
  authRight: 'assets/images/auth_right.png',
  SocialIcon: 'assets/images/google_icon.svg',
  SocialIcon2: 'assets/images/apple_icon.svg',
  SocialIcon3: 'assets/images/fb_icon.svg',
  parentIcon: 'assets/images/parent_icon.png',
  studentIcon: 'assets/images/student_icon.png',
  listIcon: 'assets/images/list.svg',

  dashboardIcon: 'assets/images/dashboardIcon.svg',
  tutoringIcon: 'assets/images/tutoringIcon.svg',
  counsellingIcon: 'assets/images/counsellingIcon.svg',
  sessionIcon: 'assets/images/sessionIcon.svg',
  actionIcon: 'assets/images/actionIcon.svg',
  calendarIcon: 'assets/images/calendarIcon.svg',
  coursesIcon: 'assets/images/coursesIcon.svg',
  communicationIcon: 'assets/images/communicationIcon.svg',
  notificationIcon: 'assets/images/notificationIcon.svg',
  earningIcon: 'assets/images/earning.svg',
  supportIcon: 'assets/images/supportIcon.svg',
  quizToPlay: 'assets/images/quizButtonLight@3x.png',
  quizComplete: 'assets/images/quizButtonLight@3x.png',
  attendence: 'assets/images/attendence.svg',
  engagement: 'assets/images/engagement.svg',
  tutoringhrs: 'assets/images/tutoringhrs.svg',
  counsellinghrs: 'assets/images/counsellinghrs.svg',
  userPlaceholder: 'assets/images/placeholderlogo.png',
  tickIcon: 'assets/images/tick_icon.svg',
  serviceImg: 'assets/images/service_img.svg',
  serviceImg2: 'assets/images/service_img2.svg',
  serviceImg3: 'assets/images/service_img3.svg',
  serviceImg4: 'assets/images/service_img4.svg',
  serviceImg5: 'assets/images/service_img5.svg',
  serviceImg6: 'assets/images/service_img6.svg',
  serviceImg7: 'assets/images/service_img7.svg',
  serviceImg8: 'assets/images/service_img8.svg',
  serviceImg9: 'assets/images/service_img9.svg',
  downArrow: 'assets/images/down_arrow_icon.svg',
  profileIcon: 'assets/images/profile_icon.svg',
  profileIcon2: 'assets/images/profile_icon2.svg',
  profileIcon3: 'assets/images/profile_icon3.svg',
  profileIcon4: 'assets/images/profile_icon4.svg',
  fileIcon4:'assets/images/file_icon4.svg',
  profileIcon5: 'assets/images/profile_icon5.svg',
  profileIcon6: 'assets/images/profile_icon6.svg',
  profileIcon7: 'assets/images/profile_icon7.svg',
  paymentMethod: 'assets/images/payment_method_icon.svg',
  tutoring: 'assets/images/tutoring.svg',
  counselling: 'assets/images/counselling.svg',

  profileIcon8: 'assets/images/profile_icon8.svg',
  trashIcon: 'assets/images/trash_icon.svg',
  aboutIcon: 'assets/images/about_us_icon.svg',
  termIcon: 'assets/images/term_icon.svg',
  privacyIcon: 'assets/images/privacy_icon.svg',
  faqIcon: 'assets/images/faq_icon.svg',
  visaIcon: 'assets/images/visa_icon.png',
  masterIcon: 'assets/images/mastercard_icon.png',
  personalityIcon: 'assets/images/personality.svg',
  interestIcon: 'assets/images/interest.svg',
  aptitudeIcon: 'assets/images/aptitude.svg',
  intelligenceIcon: 'assets/images/intelligence.svg',
  preferenceIcon: 'assets/images/preference.svg',
  view_result: 'assets/images/view_result.svg',
  plusIcon: 'assets/images/plus_icon.svg',
  support_Icon: 'assets/images/support_icon.svg',
  ticketIcon: 'assets/images/ticket_icon.svg',
  uploadIcon:'assets/images/upload_icon.svg',
  pinIcon:'assets/images/pin_icon.svg',
  settingIcon1:'assets/images/setting_icon.svg',
  signOutIcon:'assets/images/logout_icon.svg',
  filterIcon: 'assets/images/filter.svg',
  courseImage1:'assets/images/course_image1.jpg',
  circle_tick_outline: 'assets/images/circle_tick_outline.svg',
  circle_tick_filled: 'assets/images/circle_tick_filled.svg',
  course_big_image: 'assets/images/course_big_image.jpg',
  clockIcon: 'assets/images/clockIcon.svg',
  lock_icon: 'assets/images/lock_icon.svg',
  tutorIcon: 'assets/images/tutor_icon.svg',
  counslorIcon: 'assets/images/counselor_icon.png',
  todomain_img: 'assets/images/todomain_img.jpg',
  trash: 'assets/images/trash.svg',
  edit: 'assets/images/edit.svg',
  message: 'assets/images/message.svg',
  fileupload: 'assets/images/fileUpload.svg',
  fileIcon: 'assets/images/fileIcon.svg',
  downloadIcon: 'assets/images/downloadIcon.svg',
  studentIcon2: 'assets/images/main_student_icon.svg',
  studentIcon3: 'assets/images/main_student_icon2.svg',
  uploadedIcon: 'assets/images/uploaded_file.svg',
  cvIcon: 'assets/images/cv_file_icon.svg',
  reviewIcon: 'assets/images/profile_review.png',
  arrowIcon: 'assets/images/long_arrow.svg',
  upload_file_icon: 'assets/images/file_upload_icon.svg',
  uploadFolder: 'assets/images/folder_icon.svg',
  renameIcon: 'assets/images/rename_icon.svg',
  ViewFileIcon: 'assets/images/view_file_icon.svg',
  documentDownload: 'assets/images/document-download.svg',
  pdfIcon2:'assets/images/pdf.svg',
  docIcon2: 'assets/images/Doc_icon.png',
  jpgIcon: 'assets/images/jpg.png',
  resourceIcon:'assets/images/resourc_icon.svg',
  securityIcon:'assets/images/security_icon.svg',
  studentIcon4:'assets/images/tag-user.svg',
  counsellorIcon: 'assets/images/counsellors.png',
  packagesIcon: 'assets/images/packages.png',
  collegeListIcon: 'assets/images/sessions1.png',
  bookIcon: 'assets/images/book.png',
  starIcon: 'assets/images/star.svg',
  noData: 'assets/images/no-data.svg',
  userEdit: 'assets/images/user-edit.svg',
  tickIconStudent: 'assets/images/student_tick_icon.png',
  student: 'assets/images/encrypted-data 1.svg',
  self: 'assets/images/team-management 1.svg',
  exportIcon: 'assets/images/export_icon.svg',
  csvIcon: 'assets/images/csv1.svg',
  pdfIconDownload: 'assets/images/pdf1.svg',
  chat:'assets/images/chat_img.png',
  location:'assets/images/google_location.png',
  notificationSound: 'assets/audio/soundAlert.mp3'
};
